import { Card, Col, Row, Typography } from 'antd';
import { Link } from 'react-router-dom';
import { BankOutlined, LineChartOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const features = [
  {
    icon: <BankOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Fund Reconciliation',
    description: 'Reconcile fund orders across order and account sources by month.',
    href: '/accounting/fund-order-reconciliation',
  },
  {
    icon: <LineChartOutlined style={{ fontSize: 32, color: '#1677ff' }} />,
    title: 'Stock Reconciliation',
    description: 'Reconcile stock orders across order and account sources by month.',
    href: '/accounting/stock-order-reconciliation',
  },
];

export default function AccountingHomePage() {
  return (
    <div style={{ padding: 32 }}>
      <Title level={2}>Accounting</Title>
      <Text type="secondary" style={{ display: 'block', marginBottom: 32 }}>
        Reconciliation and accounting reports across the platform.
      </Text>

      <Row gutter={[24, 24]}>
        {features.map(feature => (
          <Col xs={24} sm={12} lg={6} key={feature.href}>
            <Link to={feature.href}>
              <Card
                hoverable
                style={{ height: '100%' }}
                styles={{ body: { display: 'flex', flexDirection: 'column', gap: 12 } }}
              >
                {feature.icon}
                <Title level={5} style={{ margin: 0 }}>{feature.title}</Title>
                <Text type="secondary">{feature.description}</Text>
              </Card>
            </Link>
          </Col>
        ))}
      </Row>
    </div>
  );
}
